import React, { useState } from 'react'

import PropTypes from 'prop-types'

import { ConfirmationDialog, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

const DeleteReceiptModal = ({ receipt, open, setOpen, refresh }) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const handleDelete = async () => {
    try {
      setLoading(true)
      await service.dponet.consent.destroyReceipt({
        consentFormId: receipt?.consentForm.id,
        id: receipt?.id,
      })

      snackbar.open({
        message: `Recibo excluído com sucesso!`,
        variant: 'success',
      })

      refresh()
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao tentar excluir o recibo',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <ConfirmationDialog
        open={open}
        setOpen={setOpen}
        text="Tem certeza de que deseja excluir este consentimento? Depois não será possível recuperá-lo!"
        textButtonCancel="Cancelar"
        textButton="Confirmar"
        actionAcceptButton={handleDelete}
      />
    </>
  )
}

DeleteReceiptModal.propTypes = {
  receipt: PropTypes.object,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
}

export default DeleteReceiptModal
